/*
 * @Author: jhonsem
 * @Date: 2021-01-28 14:53:08
 * @Last Modified by: jhonsem
 * @Last Modified time: 2021-03-31 17:44:56
 *
 * https://fonts.google.com/specimen/Noto+Sans?sidebar.open=true&selection.family=Noto+Sans:wght@700
 * https://fonts.google.com/specimen/Varela+Round?sidebar.open=true&selection.family=Varela+Round
 * https://fonts.google.com/specimen/Poppins?sidebar.open=true&selection.family=Poppins:wght@600
 */
import { WEB_FONT_URL } from "@/config/index";

export const font_loader = () => {
  window.WebFontConfig = {
    google: {
      families: ["Work Sans:400,500,600,700"]
      // normal ,medium,bold
    }
  };

  // 异步添加字体:

  const wf = document.createElement("script");
  const script: any = document.scripts[0];
  wf.src = WEB_FONT_URL;
  wf.async = true;
  script.parentNode.insertBefore(wf, script);
};
